import React, { Component } from 'react';
import './AmCharts.css';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { isNullOrUndefined, isUndefined } from "util";

am4core.useTheme(am4themes_animated);

class AmMicroChart extends React.Component {
    
    constructor(props){

        //id, title, xAxis, yAxis, data, colorUp, colorDown
        super(props);

        this.chart = null;
        this.createColumn = this.createColumn.bind(this);
        this.formatDataArray = this.formatDataArray.bind(this);
    }

    createColumn(title, data, color, container) {

        let chart = container.createChild(am4charts.XYChart);
        chart.width = am4core.percent(100);
        chart.height = 80;
    
        chart.data = data;
 
    
        // chart.padding(2, 5, 2, 5);

        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = this.props.xAxis;
        categoryAxis.renderer.grid.template.disabled = true;
        categoryAxis.renderer.labels.template.disabled = true;
        categoryAxis.cursorTooltipEnabled = false;
    
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.baseValue = 0;
        valueAxis.renderer.grid.template.disabled = true;
        // valueAxis.renderer.baseGrid.disabled = true;
        valueAxis.renderer.labels.template.disabled = true;
        valueAxis.cursorTooltipEnabled = false;
    
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.lineY.disabled = true;
        chart.cursor.behavior = "none";

        var series = chart.series.push(new am4charts.ColumnSeries());
        series.tooltipText = "{"+this.props.xAxis+"} \n[bold]{"+this.props.yAxis+"}";
        series.dataFields.categoryX = this.props.xAxis;
        series.dataFields.valueY = this.props.yAxis;
        series.strokeWidth = 0;
        series.fillOpacity = 0.9;
        series.columns.template.propertyFields.fillOpacity = "opacity";
        series.columns.template.fill = color;
        series.columns.template.width = am4core.percent(50);
    
        let scope = this;
        series.columns.template.adapter.add("fill", function(fill, target) {
            if (target.dataItem && (target.dataItem.valueY < 0)) {
                if(!isNullOrUndefined(scope.props.lowColor)){
                    return am4core.color(scope.props.lowColor);                    
                }
              return am4core.color("#a55");
            }
            else {
              return fill;
            }
          });
          
        chart.export = { "enabled": true}
        return chart;
      }

      formatDataArray(data){
          let yAxis = this.props.yAxis;
          let xAxis = this.props.xAxis;

          let newData = [];
          for(let i=0; i<data.length; i++){
              let currData = data[i];
              if(xAxis in currData && yAxis in currData){
                  newData.push(currData); 
              }
          }
          // console.log(data, newData);
          return newData;
      }

    componentDidMount(){
        // Create chart instance
        let container = am4core.create("AmMicroChart_"+String(this.props.id), am4core.Container);
        container.layout = "grid";
        container.fixedWidthGrid = false;
        container.width = am4core.percent(100);
        container.height = am4core.percent(100);

        // Color set
        let color = am4core.color("green");
        if(!isNullOrUndefined(this.props.highColor)){
            color = am4core.color(this.props.highColor);
        }

        this.chart = this.createColumn(this.props.title, this.formatDataArray(this.props.data), color, container);
        if(!isNullOrUndefined(this.props.amCharts) && !isNullOrUndefined(this.props.title) && !isNullOrUndefined(this.props.setAmChart)){
            this.props.setAmChart(this.props.title, this.chart);
        }
    }

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
            if(!isNullOrUndefined(this.props.amCharts) && !isNullOrUndefined(this.props.title) && !isNullOrUndefined(this.props.setAmChart)){
                this.props.setAmChart(this.props.title, null);
            }
        }
    }

    render(){
        return (
            <div>
                <h6 style={{textAlign:'center', marginTop:'10px'}}>{this.props.title}</h6>
                <div id={"AmMicroChart_"+String(this.props.id)} className="chartdiv"></div>
            </div>

        )
    }
}
export default AmMicroChart;

/* 
[
            { "date": "2018-01-01", "value": 57 },
            { "date": "2018-02-01", "value": 27 },
            { "date": "2018-03-01", "value": 24 },
            { "date": "2018-04-01", "value": 59 },
            { "date": "2018-05-01", "value": 33 },
            { "date": "2018-06-01", "value": 46 },
            { "date": "2018-07-01", "value": 20 },
            { "date": "2018-08-01", "value": 42 },
            { "date": "2018-09-01", "value": 59, "opacity": 1}
           ]
           */